module.exports = __webpack_public_path__ + "static/google-play-badge-6cffa5312a2bb047505049b47edf0d26.svg";